export const GET_BOOK_SUCCESS = 'GET_BOOK_SUCCESS';
export const CHANGE_GROUP = 'CHANGE_GROUP';
export const CHANGE_VIDEO_TYPE = 'CHANGE_VIDEO_TYPE';
export const ADD_VIDEO_TO_FAVORITE_LIST = 'ADD_VIDEO_TO_FAVORITE_LIST';
export const LOADING_MESSAGE = 'Book Loading ...';
export const GET_QUESTION_LIST_SUCCESS = 'GET_QUESTION_LIST_SUCCESS';
export const SET_REVIEW_QUESTION_LIST = 'SET_REVIEW_QUESTION_LIST';
export const SET_IS_IN_REVIEW = 'SET_IS_IN_REVIEW';
export const GET_BEFORE_PRACTICE_SUCCESS = 'GET_BEFORE_PRACTICE_SUCCESS';
export const GET_AFTER_PRACTICE_SUCCESS = 'GET_AFTER_PRACTICE_SUCCESS';
export const GET_BEFORE_CHALLENGE_SUCCESS = 'GET_BEFORE_CHALLENGE_SUCCESS';
export const GET_AFTER_CHALLENGE_SUCCESS = 'GET_AFTER_CHALLENGE_SUCCESS';
export const GET_QUESTION_SUCCESS = 'GET_QUESTION_SUCCESS';
export const UPDATE_QUESTION_HTML_SUCCESS = 'UPDATE_QUESTION_HTML_SUCCESS';
export const SAVE_QUESTION_RANGY_MARK = 'SAVE_QUESTION_RANGY_MARK';
export const RESET_QUESTION_LIST_QUESTION_STATUS = 'RESET_QUESTION_LIST_QUESTION_STATUS';
export const ANSWER_SUCCESS = 'ANSWER_SUCCESS';
export const QUESTION_SUBMITTED_SUCCESS = 'QUESTION_SUBMITTED_SUCCESS';
export const MARK_QUESTION_SUCCESS = 'MARK_QUESTION_SUCCESS';
export const SET_IS_REQUEST_STATUS = 'SET_IS_REQUEST_STATUS';
export const UPDATE_SUBJECT_STATUS = 'UPDATE_SUBJECT_STATUS';
export const UPDATE_SUBJECT_LIST_STATUS = 'UPDATE_SUBJECT_LIST_STATUS';
export const SET_QUESTION = 'SET_QUESTION';
export const FILE_GENERATED_SUCCESS = 'FILE_GENERATED_SUCCESS';
export const SET_BULLET_STATUS = 'SET_BULLET_STATUS';
export const HIDE_FILE_DOWN_LOAD_TIP = 'HIDE_FILE_DOWN_LOAD_TIP';
export const RESET_BOOK_POINTS = 'RESET_BOOK_POINTS';
export const BOOK_MASTER_LEVEL = '4';
export const SET_IS_HIDE_FILE_DOWN_TIP_STATUS = 'SET_IS_HIDE_FILE_DOWN_TIP_STATUS';
export const SET_BOOK_LEVEL_UP_TO = 'SET_BOOK_LEVEL_UP_TO';
export const SET_COURSE_LEVEL_UP_TO = 'SET_COURSE_LEVEL_UP_TO';
export const SET_BOOK_LEVEL_UP_STATUS = 'SET_BOOK_LEVEL_UP_STATUS';
export const SET_COURSE_LEVEL_UP_STATUS = 'SET_COURSE_LEVEL_UP_STATUS';
export const UPDATE_PRE_CHALLENGE = 'UPDATE_PRE_CHALLENGE';
export const NOTE_SAVED_SUCCESS = 'NOTE_SAVED_SUCCESS';
export const SET_LAST_PROGRESS = 'SET_LAST_PROGRESS';
